import {XHTTP} from '@/shared/xhttp';
import {LivraisonService} from "@/xhttp";
import {Achat} from "@/models/Achat";
import {LongueursAchat} from "@/models/LongueursAchat";
import {EssenceAchat} from "@/models/EssenceAchat";
import {DateHelper} from "@/shared/utils";
import {ReglementType} from "@/models/SuiviReglement";
import {Transporteur} from "@/models/Transporteur";

export type DestType = 'Depôt'|'Autre';
export const DestType = {
	Depot   : 'Depôt' as DestType,
	Autre	: 'autre' as DestType,
};

@XHTTP(LivraisonService, '/livraisons')
export class Livraison {


	private _id: number;
	private _date: Date = new Date();
	private _essenceAchat: EssenceAchat;
	private _transporteur: Transporteur;
	private _destType: DestType = DestType.Depot;
	private _destination: string;
	private _chauffeur: string;
	private _volume: number;
	private _payer: boolean;
	private _facture: boolean;
	private _createdAt: Date;
	private _typeBois: string;
	private _remarques: string;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get essenceAchat(): EssenceAchat {
		return this._essenceAchat;
	}

	public get transporteur(): Transporteur {
		return this._transporteur;
	}

	public get typeBois(): string {
		return this._typeBois;
	}

	public get chauffeur(): string {
		return this._chauffeur;
	}

	public get volume(): number {
		return this._volume;
	}

	public get destination(): string {
		return this._destination;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	public get destType(): DestType {
		return this._destType ? <any>this._destType.toString() : null;
	}

	public get payer(): boolean {
		return this._payer;
	}

	public get facture(): boolean {
		return this._facture;
	}

	public get remarques(): string {
		return this._remarques;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set essenceAchat(value: EssenceAchat) {
		this._essenceAchat = value;
	}

	public set transporteur(value: Transporteur) {
		this._transporteur = value;
	}

	public set typeBois(value: string) {
		this._typeBois = value;
	}

	public set chauffeur(value: string) {
		this._chauffeur = value;
	}

	public set volume(value: number) {
		this._volume = value;
	}

	public set destination(value: string) {
		this._destination = value;
	}

	public set destType(value: DestType) {
		this._destType = value;
		if (value == DestType.Depot) {
			this.destination = "depot";
		} else {
			this.destination = "";
		}
	}

	public set payer(value: boolean) {
		this._payer = value;
	}

	public set facture(value: boolean) {
		this._facture = value;
	}

	public set remarques(value: string) {
		this._remarques = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date ? DateHelper.toLocalizedString(this._date) : null,
			essenceAchat : this._essenceAchat ? this._essenceAchat.id : null,
			transporteur : this._transporteur ? this._transporteur.id : null,
			volume : this._volume,
			destination   : this._destination,
			destType : this._destType ? this._destType.toString() : null,
			payer   : this._payer,
			facture   : this._facture,
			chauffeur: this._chauffeur,
			remarques: this._remarques,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date   = data.date ? new Date(data.date) : null;
		this._essenceAchat  = data.essenceAchat ? (new EssenceAchat()).fromJSON(data.essenceAchat) : null;
		this._transporteur  = data.transporteur ? (new Transporteur()).fromJSON(data.transporteur) : null;
		this._volume  = data.volume;
		this._destination    = data.destination;
		this._createdAt   = data.createdAt ? new Date(data.createdAt) : null;
		this._destType	   = data.destType;
		if (this._essenceAchat) {
			if (this.essenceAchat.boisType) {
				this._typeBois	= this.essenceAchat.boisType.name
			}
		}
		this._payer    = data.payer;
		this._facture    = data.facture;
		this._chauffeur = data.chauffeur;
		this._remarques =data.remarques;
		return this;
	}
}
